import { useEffect } from 'react';

interface Props {
  isFiltersHiddenHandler(): void;
}
export const useBranchesListEffects = ({ isFiltersHiddenHandler }: Props) => {
  useEffect(() => {
    isFiltersHiddenHandler();
  }, [isFiltersHiddenHandler]);
};
